export function ProductCommissionPolicyService($http, $q, apexApiUrl) {
    'ngInject';
    const service = {
        retrieveProductCommissionPolicies: retrieveProductCommissionPolicies,
        retrieveProductCommissionPolicy: retrieveProductCommissionPolicy,
        createProductCommissionPolicy: createProductCommissionPolicy,
        updateProductCommissionPolicy: updateProductCommissionPolicy,
        deleteProductCommissionPolicy: deleteProductCommissionPolicy,
        duplicateProductCommissionPolicyExists: duplicateProductCommissionPolicyExists,
        bulkUpsetProductCommision: bulkUpsetProductCommision
    };

    return service;

    function retrieveProductCommissionPolicies() {
        return $http({
            method: "GET",
            url: apexApiUrl + "product-commission-policies/",
            headers: {
                Accept: 'application/json'
            }
        }).then(function (response) {
            return response.data;
        })
    }

    function retrieveProductCommissionPolicy(productCommissionPolicyID) {
        return $http({
            method: "GET",
            url: apexApiUrl + "product-commission-policies/" + productCommissionPolicyID,
            headers: {
                Accept: "application/json"
            }
        }).then(function (response) {
            return response.data;
        });
    }

    function createProductCommissionPolicy(productCommissionPolicy) {
        return $http({
            method: "POST",
            url: apexApiUrl + "product-commission-policies",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            data: productCommissionPolicy
        }).then(function (response) {
            return response.data;
        });
    }

    function updateProductCommissionPolicy(productCommissionPolicyID, productCommissionPolicy) {
        return $http({
            method: "PUT",
            url: apexApiUrl + "product-commission-policies/" + productCommissionPolicyID,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            data: productCommissionPolicy
        })
    }

    function deleteProductCommissionPolicy(productCommissionPolicyID) {
        return $http({
            method: "DELETE",
            url: apexApiUrl + "product-commission-policies/" + productCommissionPolicyID
        }).then(function (response) {
            return response.data;
        });
    }

    function bulkUpsetProductCommision(policies) {
        return $http({
            method: "POST",
            url: apexApiUrl + "product-commission-policies/bulk",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            data: policies
        }).then(function (response) {
            return response.data;
        });

    }

    function duplicateProductCommissionPolicyExists(commissionPolicy, commissionPolicies) {
        let anyDuplicates = false;
        if (commissionPolicy.Product && commissionPolicy.ProductLine) {
            anyDuplicates = commissionPolicies.reduce(function (any, other) {
                return any || other !== commissionPolicy
                    && other.Product && other.Product.ProductID === commissionPolicy.Product.ProductID
                    && other.ProductLine
                    && other.ProductLine.ProductLineID === commissionPolicy.ProductLine.ProductLineID;
            }, false);
        }
        return anyDuplicates;
    }

}
